  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0">{{ projectName }} - {{labels.title}}</p>
    <p
      class="text-[#343A40] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] !w-[240px] !h-[19px] flex items-center justify-center"
    >
      Tender Submission instructions
    </p>
  </div>
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <!-- Tender Submission Deadline Date  -->
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Tender Submission Deadline Date </mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [formControl]="tenderSubmissionDeadlineDateControl"
            placeholder="Tender Submission Deadline"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker startView="year"></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="tenderSubmissionDeadlineDateControl.invalid && tenderSubmissionDeadlineDateControl.touched"
          class="relative top-[-15px]"
        >
          Tender Submission Deadline Date is required.
        </mat-error>
      </div>
    </div>
<!-- Tender Submission Deadline Time -->
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <app-input-timepicker
        label="Tender Submission Deadline Time"
        [required]="true"
        [control]="tenderSubmissionDeadlineTimeControl"
        errorMessage="Tender Submission Deadline Time is required."
        ></app-input-timepicker>
      </div>
    </div>
  </div>
<!-- Select projects Drawings PDF  -->
  <!-- <div class="!mb-4 pl-[50px]">
    <label for="contractFile" class="block file_label !text-[15px] !mb-3 !font-medium"
      >Project Drawing
    </label>
    <div class="w-[100%] flex justify-between items-center">
      <div class="flex justify-start !h-[50px]">
        <input
          type="checkbox"
          class="h-[20px] w-[20px] mr-[12px]"
          [checked]="selectAllChecked"
        />
        <p class="packages-name text-[#3B71CA]">
          {{ selectAllChecked ? "Deselect All" : "Select All" }}
        </p>
      </div>
    </div>
    <div class="w-[100%] flex justify-between items-center">
      <div class="flex justify-start !h-[50px]">
        <input type="checkbox" class="h-[20px] w-[20px] mr-[12px]" />
        <p class="packages-name flex">
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5484 0H2.7017C2.42755 0 2.20532 0.222232 2.20532 0.653464V18.6607C2.20532 18.7778 2.42755 19 2.7017 19H16.2982C16.5724 19 16.7946 18.7778 16.7946 18.6607V4.40325C16.7946 4.16711 16.7631 4.09111 16.7074 4.03512L12.7595 0.0871964C12.7035 0.0315536 12.6275 0 12.5484 0Z"
              fill="#E9E9E0"
            />
            <path
              d="M12.7231 0.0546875V4.07488H16.7433L12.7231 0.0546875Z"
              fill="#D9D7CA"
            />
            <path
              d="M6.62073 11.3063C6.50266 11.3063 6.38934 11.268 6.29264 11.1957C5.93945 10.9307 5.89195 10.6359 5.91434 10.435C5.97609 9.88268 6.65907 9.30454 7.94497 8.71554C8.45525 7.59725 8.94077 6.21941 9.23018 5.06821C8.89157 4.33129 8.56247 3.37518 8.80234 2.81434C8.88648 2.61789 8.99132 2.46725 9.18709 2.40211C9.26445 2.37632 9.45988 2.34375 9.5318 2.34375C9.7028 2.34375 9.85311 2.56395 9.95964 2.69966C10.0597 2.82723 10.2867 3.09764 9.83309 5.00748C10.2904 5.95205 10.9385 6.91427 11.5594 7.57316C12.0042 7.49275 12.3869 7.4517 12.6987 7.4517C13.23 7.4517 13.552 7.57554 13.6833 7.83068C13.7919 8.04171 13.7474 8.28838 13.551 8.56354C13.362 8.82784 13.1014 8.96762 12.7978 8.96762C12.3852 8.96762 11.9048 8.70705 11.369 8.19236C10.4065 8.39355 9.28243 8.75252 8.37382 9.14982C8.09018 9.75171 7.81841 10.2366 7.5653 10.5921C7.21754 11.079 6.91761 11.3063 6.62073 11.3063ZM7.52391 9.56714C6.79886 9.97463 6.50334 10.3095 6.48197 10.4981C6.47857 10.5294 6.46941 10.6115 6.6282 10.7329C6.67875 10.717 6.97393 10.5823 7.52391 9.56714ZM12.1508 8.06004C12.4273 8.27277 12.4948 8.38032 12.6756 8.38032C12.755 8.38032 12.9813 8.37693 13.0862 8.2307C13.1367 8.15979 13.1564 8.11432 13.1642 8.08989C13.1225 8.06784 13.0672 8.02305 12.7655 8.02305C12.5942 8.02339 12.3788 8.03086 12.1508 8.06004ZM9.61629 5.82686C9.3737 6.66625 9.05341 7.57248 8.70904 8.39321C9.41814 8.11805 10.189 7.87784 10.913 7.70786C10.455 7.17586 9.9973 6.51154 9.61629 5.82686ZM9.41034 2.95582C9.37709 2.96702 8.95909 3.55195 9.44291 4.04696C9.76489 3.32938 9.42493 2.95107 9.41034 2.95582Z"
              fill="#CC4B4C"
            />
            <path
              d="M16.2982 19.0022H2.7017C2.42755 19.0022 2.20532 18.78 2.20532 18.5059V13.2344H16.7946V18.5059C16.7946 18.78 16.5724 19.0022 16.2982 19.0022Z"
              fill="#CC4B4C"
            />
            <path
              d="M5.89844 17.9811H5.34167V14.5625H6.32492C6.47014 14.5625 6.614 14.5856 6.75616 14.6321C6.89832 14.6785 7.02589 14.7481 7.13887 14.8407C7.25185 14.9333 7.34312 15.0456 7.41267 15.1769C7.48223 15.3083 7.51717 15.4558 7.51717 15.6201C7.51717 15.7934 7.48766 15.9502 7.42896 16.091C7.37026 16.2318 7.28816 16.3502 7.18298 16.4459C7.0778 16.5416 6.95091 16.6159 6.80264 16.6684C6.65437 16.721 6.49016 16.7472 6.31101 16.7472H5.8981L5.89844 17.9811ZM5.89844 14.9846V16.339H6.40873C6.47659 16.339 6.54376 16.3275 6.6106 16.3041C6.6771 16.281 6.73817 16.243 6.79382 16.1904C6.84946 16.1378 6.89425 16.0645 6.92817 15.9702C6.9621 15.8759 6.97907 15.7592 6.97907 15.6201C6.97907 15.5644 6.97126 15.4999 6.956 15.4277C6.94039 15.3551 6.90884 15.2855 6.861 15.219C6.81282 15.1525 6.74564 15.0969 6.65912 15.0521C6.5726 15.0073 6.45792 14.9849 6.31576 14.9849L5.89844 14.9846Z"
              fill="white"
            />
            <path
              d="M10.9314 16.1768C10.9314 16.4581 10.9012 16.6986 10.8408 16.8981C10.7804 17.0976 10.704 17.2646 10.6111 17.3993C10.5181 17.534 10.4139 17.6398 10.2979 17.7172C10.1819 17.7945 10.0699 17.8522 9.96168 17.8912C9.85344 17.9299 9.75437 17.9547 9.6648 17.9655C9.57523 17.9757 9.50873 17.9811 9.4653 17.9811H8.17126V14.5625H9.201C9.48871 14.5625 9.74148 14.6083 9.9593 14.6992C10.1771 14.7902 10.3583 14.912 10.5022 15.0633C10.646 15.2146 10.7532 15.3873 10.8245 15.5804C10.8957 15.7738 10.9314 15.9726 10.9314 16.1768ZM9.28005 17.573C9.65734 17.573 9.92944 17.4525 10.0964 17.2113C10.2633 16.9701 10.3468 16.6206 10.3468 16.1629C10.3468 16.0207 10.3298 15.8799 10.2959 15.7408C10.2616 15.6017 10.1961 15.4759 10.0987 15.3629C10.0014 15.2499 9.86905 15.1586 9.70212 15.0891C9.53519 15.0195 9.31873 14.9846 9.05273 14.9846H8.72803V17.573H9.28005Z"
              fill="white"
            />
            <path
              d="M12.3045 14.9846V16.0608H13.7332V16.4411H12.3045V17.9811H11.7385V14.5625H13.8767V14.9846H12.3045Z"
              fill="white"
            />
          </svg>
          Project_Drawings_Site_Plan.pdf
        </p>
      </div>
    </div>
  </div> -->
  <!-- Submission Address  -->
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Submission Address </mat-label>
          <input
            matInput
            type="text"
            [formControl]="tenderSubmissionDeadlineAddressControl"
            placeholder="Submission Address"
          />
        </mat-form-field>
        <mat-error
          *ngIf="tenderSubmissionDeadlineAddressControl.invalid && tenderSubmissionDeadlineAddressControl.touched"
          class="relative top-[-15px]"
        >
          Submission Address is required.
        </mat-error>
      </div>
    </div>
  </div>
  <!-- Back and next Buttons -->
  <div
    class="relative bottom-0 right-0 !pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="moveToPreviousStep()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
